export default __webpack_public_path__ + "static/media/Logo-InofBotani-10-1.f7db6cea.png";